import React, { useState, useEffect } from "react";
import { Box, Drawer, Skeleton, Typography } from "@mui/material";
import * as S from "./styles";
import { Desafio } from "./desafio";

import { DesafioCard } from "./desafioCard";
import { returnEnvironment } from "../../utils";
import { useNavigate } from "react-router-dom";
import { apiGetDesafios } from "../../services/apiGetDesafios";

export const DesafiosBar = ({ comunidade }) => {
    const [selectedDesafio, setSelectedDesafio] = useState(null);
    const [desafios, setDesafios] = useState([]);
    const [ isLoading, setIsLoading ] = useState(true);

    useEffect(() => {
        const fetchDesafios = async () => {
            setIsLoading(true);
            try {
                if (comunidade?.id) {
                    const response = await apiGetDesafios({ comunidade: comunidade.id });
                    setDesafios(response);
                }
            } catch (error) {
                console.error("Erro ao buscar desafios:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDesafios();
    }, [comunidade?.id]);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const navigate = useNavigate();
    const isWizard = returnEnvironment() === "wizard";

    const openDesafioDrawer = (desafio) => {
        setSelectedDesafio(desafio);
        setDrawerOpen(true);
    };

    const closeDesafioDrawer = () => {
        setDrawerOpen(false);
        setSelectedDesafio(null);
    };

    return (
        <>
            <S.Container>
                <S.Title variant="h5">Desafios para pontuar</S.Title>
                <S.ScrollContainer>
                    {isLoading && (
                        Array.from({ length: 2 }).map((_, index) => (
                            <Skeleton
                                key={index}
                                variant="rounded"
                                width={'286px'}
                                height={'120px'}
                            />
                        ))
                    )}

                    {comunidade && !isLoading && (
                        <DesafioCard
                            desafio={{
                                titulo: "Postar no feed",
                                pontos: 100,
                            }}
                            isWizard={isWizard}
                            onClick={() => navigate(`/novoPost/${comunidade?.id}`, { state: { comunidade } })}
                            width="270px"
                        />
                    )}

                    {desafios.length > 0 && !isLoading && (
                        desafios.map((desafio, index) => (
                            <DesafioCard
                                key={index}
                                desafio={desafio}
                                isWizard={isWizard}
                                onClick={() => openDesafioDrawer(desafio)}
                            />
                        ))
                    )}
                </S.ScrollContainer>
                <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", mt: 1 }}>
                    <Typography
                        onClick={() => navigate("/desafios", { state: { comunidade } })}
                        sx={{
                            cursor: "pointer",
                            color: "var(--primary-color)",
                            fontWeight: "bold",
                            textDecoration: "underline",
                            fontSize: "var(--font-size-small, 0.85rem)",
                        }}
                    >
                        Ver todos
                    </Typography>
                </Box>
            </S.Container>

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={closeDesafioDrawer}
                sx={{
                    "& .MuiDrawer-paper": {
                        padding: 2,
                        width: "100%",
                        maxWidth: "600px",
                        height: "100%",
                        backgroundColor: "var(--white-color)",
                        overflowY: "auto",
                    },
                }}
            >
                {selectedDesafio && (
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Desafio desafio={selectedDesafio} closeModal={closeDesafioDrawer} />
                    </Box>
                )}
            </Drawer>
        </>
    );
};
